import { GAME_FLOW_TYPES } from '../consts/gameFlowTypes'

export const loadStage = stage => ({
  type: GAME_FLOW_TYPES.LOAD_STAGE,
  stage,
})

export const upForceLoadStage = stage => ({
  type: GAME_FLOW_TYPES.UP_FORCE_LOAD_STAGE,
  stage,
  meta: {
    sendServer: true,
  }
})

// Client
export const cltRefreshRoleDistribution = () => ({
  type: GAME_FLOW_TYPES.CLT_REFRESH_ROLE_DISTRIBUTION,
})

// Server
export const setValidStages = stages => ({
  type: GAME_FLOW_TYPES.SET_VALID_STAGES,
  stages
})